<template>
    <div>
       <HeaderTeam header="รายงานและการสรุปยอด" :img_header="header_image" link_back="summary"/>
       <MenuTeamReportAndSummaryList/>
       <PartTimeSummaryList/>
    </div>
</template>

<script>
import HeaderImage from '@/assets/dashboard.png'
import HeaderTeam from '@/components/menuadmin/team/teamheader/HeaderTeam.vue'
import MenuTeamReportAndSummaryList from '@/components/menuadmin/team/teamreportandsummary/MenuTeamReportAndSummaryList.vue'
import PartTimeSummaryList from '@/components/menuadmin/team/teamreportandsummary/PartTimeSummaryList.vue'
export default {
    name:'partTimeSummary',
    components:{
        HeaderTeam,
        MenuTeamReportAndSummaryList,
        PartTimeSummaryList,
    },
    data(){
        return{
            header_image:HeaderImage
        }
    }
}
</script>